import { render, staticRenderFns } from "./sample.vue?vue&type=template&id=bbe306ca&scoped=true&"
var script = {}
import style0 from "./sample.vue?vue&type=style&index=0&id=bbe306ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbe306ca",
  null
  
)

export default component.exports